var _toArray = require("G:/Work/Primary360/ahdc-squid/node_modules/@babel/runtime/helpers/toArray");

var _slicedToArray = require("G:/Work/Primary360/ahdc-squid/node_modules/@babel/runtime/helpers/slicedToArray");

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "/dist/", r(r.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  r.r(t);
  var n = r(0),
      o = r.n(n);

  function a(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function i(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? a(Object(r), !0).forEach(function (t) {
        l(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : a(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function l(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  var s = function s(e) {
    var t = e.aspectRatio,
        r = e.handle,
        a = e.handleSize,
        l = e.hover,
        s = e.leftImage,
        u = e.leftImageAlt,
        c = e.leftImageCss,
        d = e.leftImageLabel,
        p = e.onSliderPositionChange,
        g = e.rightImage,
        f = e.rightImageAlt,
        b = e.rightImageCss,
        h = e.rightImageLabel,
        m = e.skeleton,
        x = e.sliderLineColor,
        v = e.sliderLineWidth,
        w = e.sliderPositionPercentage,
        y = e.vertical,
        O = !y,
        _Object = Object(n.useState)(w),
        _Object2 = _slicedToArray(_Object, 2),
        E = _Object2[0],
        L = _Object2[1],
        _Object3 = Object(n.useState)(0),
        _Object4 = _slicedToArray(_Object3, 2),
        j = _Object4[0],
        S = _Object4[1],
        _Object5 = Object(n.useState)(0),
        _Object6 = _slicedToArray(_Object5, 2),
        I = _Object6[0],
        P = _Object6[1],
        _Object7 = Object(n.useState)(!1),
        _Object8 = _slicedToArray(_Object7, 2),
        C = _Object8[0],
        $ = _Object8[1],
        _Object9 = Object(n.useState)(!1),
        _Object10 = _slicedToArray(_Object9, 2),
        R = _Object10[0],
        k = _Object10[1],
        _Object11 = Object(n.useState)(!1),
        _Object12 = _slicedToArray(_Object11, 2),
        z = _Object12[0],
        A = _Object12[1],
        D = Object(n.useRef)(null),
        M = Object(n.useRef)(null),
        _ = Object(n.useRef)(null);

    Object(n.useEffect)(function () {
      var e = D.current,
          t = new ResizeObserver(function (_ref) {
        var _ref2 = _toArray(_ref),
            e = _ref2[0],
            t = _ref2.slice(1);

        var r = e.target.getBoundingClientRect().width;
        S(r);
      });
      return t.observe(e), function () {
        return t.disconnect();
      };
    }, []), Object(n.useEffect)(function () {
      return _.current.complete && $(!0), function () {
        $(!1);
      };
    }, [s]), Object(n.useEffect)(function () {
      return M.current.complete && k(!0), function () {
        k(!1);
      };
    }, [g]);
    var W = R && C;
    Object(n.useEffect)(function () {
      var e = function e(_e) {
        var t = _e || window.event,
            r = t.touches ? t.touches[0].pageX : t.pageX,
            n = t.touches ? t.touches[0].pageY : t.pageY,
            o = r - window.pageXOffset,
            a = n - window.pageYOffset,
            i = M.current.getBoundingClientRect();
        var l = O ? o - i.left : a - i.top;
        var s = 0 + v / 2,
            u = O ? j - v / 2 : I - v / 2;
        l < s && (l = s), l > u && (l = u), L(O ? l / j : l / I), p && p(O ? l / j : l / I);
      },
          r = function r(t) {
        A(!0), "touches" in t || t.preventDefault(), e(t), window.addEventListener("mousemove", e), window.addEventListener("touchmove", e);
      },
          n = function n() {
        A(!1), window.removeEventListener("mousemove", e), window.removeEventListener("touchmove", e);
      },
          o = D.current;

      if (W) {
        o.addEventListener("touchstart", r), window.addEventListener("touchend", n), l ? (o.addEventListener("mousemove", e), o.addEventListener("mouseleave", n)) : (o.addEventListener("mousedown", r), window.addEventListener("mouseup", n));

        var _a = _.current.naturalHeight / _.current.naturalWidth,
            _i = M.current.naturalHeight / M.current.naturalWidth,
            _s = "taller" === t ? Math.max(_a, _i) : Math.min(_a, _i);

        P(j * _s);
      }

      return function () {
        o.removeEventListener("touchstart", r), window.removeEventListener("touchend", n), o.removeEventListener("mousemove", e), o.removeEventListener("mouseleave", n), o.removeEventListener("mousedown", r), window.removeEventListener("mouseup", n), window.removeEventListener("mousemove", e), window.removeEventListener("touchmove", e);
      };
    }, [W, t, I, j, O, l, v, y]);
    var F = {
      container: {
        boxSizing: "border-box",
        position: "relative",
        width: "100%",
        height: I + "px",
        overflow: "hidden"
      },
      rightImage: i({
        clip: O ? "rect(auto, auto, auto, ".concat(j * E, "px)") : "rect(".concat(I * E, "px, auto, auto, auto)"),
        display: "block",
        height: "100%",
        objectFit: "cover",
        position: "absolute",
        width: "100%"
      }, b),
      leftImage: i({
        clip: O ? "rect(auto, ".concat(j * E, "px, auto, auto)") : "rect(auto, auto, ".concat(I * E, "px, auto)"),
        display: "block",
        height: "100%",
        objectFit: "cover",
        position: "absolute",
        width: "100%"
      }, c),
      slider: {
        alignItems: "center",
        cursor: !l && O ? "ew-resize" : !l && !O && "ns-resize",
        display: "flex",
        flexDirection: O ? "column" : "row",
        height: O ? "100%" : a + "px",
        justifyContent: "center",
        left: O ? j * E - a / 2 + "px" : 0,
        position: "absolute",
        top: O ? 0 : I * E - a / 2 + "px",
        width: O ? a + "px" : "100%"
      },
      line: {
        background: x,
        boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
        flex: "0 1 auto",
        height: O ? "100%" : v + "px",
        width: O ? v + "px" : "100%"
      },
      handleCustom: {
        alignItems: "center",
        boxSizing: "border-box",
        display: "flex",
        flex: "1 0 auto",
        height: "auto",
        justifyContent: "center",
        width: "auto"
      },
      handleDefault: {
        alignItems: "center",
        border: "".concat(v, "px solid ").concat(x),
        borderRadius: "100%",
        boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
        boxSizing: "border-box",
        display: "flex",
        flex: "1 0 auto",
        height: a + "px",
        justifyContent: "center",
        width: a + "px",
        transform: O ? "none" : "rotate(90deg)"
      },
      leftArrow: {
        border: "inset ".concat(.15 * a, "px rgba(0,0,0,0)"),
        borderRight: "".concat(.15 * a, "px solid ").concat(x),
        height: "0px",
        marginLeft: "-".concat(.25 * a, "px"),
        marginRight: .25 * a + "px",
        width: "0px"
      },
      rightArrow: {
        border: "inset ".concat(.15 * a, "px rgba(0,0,0,0)"),
        borderLeft: "".concat(.15 * a, "px solid ").concat(x),
        height: "0px",
        marginRight: "-".concat(.25 * a, "px"),
        width: "0px"
      },
      leftLabel: {
        background: "rgba(0, 0, 0, 0.5)",
        color: "white",
        left: O ? "5%" : "50%",
        opacity: z ? 0 : 1,
        padding: "10px 20px",
        position: "absolute",
        top: O ? "50%" : "3%",
        transform: O ? "translate(0,-50%)" : "translate(-50%, 0)",
        transition: "opacity 0.1s ease-out"
      },
      rightLabel: {
        background: "rgba(0, 0, 0, 0.5)",
        color: "white",
        opacity: z ? 0 : 1,
        padding: "10px 20px",
        position: "absolute",
        left: O ? null : "50%",
        right: O ? "5%" : null,
        top: O ? "50%" : null,
        bottom: O ? null : "3%",
        transform: O ? "translate(0,-50%)" : "translate(-50%, 0)",
        transition: "opacity 0.1s ease-out"
      },
      leftLabelContainer: {
        clip: O ? "rect(auto, ".concat(j * E, "px, auto, auto)") : "rect(auto, auto, ".concat(I * E, "px, auto)"),
        height: "100%",
        position: "absolute",
        width: "100%"
      },
      rightLabelContainer: {
        clip: O ? "rect(auto, auto, auto, ".concat(j * E, "px)") : "rect(".concat(I * E, "px, auto, auto, auto)"),
        height: "100%",
        position: "absolute",
        width: "100%"
      }
    };
    return o.a.createElement(o.a.Fragment, null, m && !W && o.a.createElement("div", {
      style: i({}, F.container)
    }, m), o.a.createElement("div", {
      style: i(i({}, F.container), {}, {
        display: W ? "block" : "none"
      }),
      ref: D,
      "data-testid": "container"
    }, o.a.createElement("img", {
      onLoad: function onLoad() {
        return k(!0);
      },
      alt: f,
      "data-testid": "right-image",
      ref: M,
      src: g,
      style: F.rightImage
    }), o.a.createElement("img", {
      onLoad: function onLoad() {
        return $(!0);
      },
      alt: u,
      "data-testid": "left-image",
      ref: _,
      src: s,
      style: F.leftImage
    }), o.a.createElement("div", {
      style: F.slider
    }, o.a.createElement("div", {
      style: F.line
    }), r ? o.a.createElement("div", {
      style: F.handleCustom
    }, r) : o.a.createElement("div", {
      style: F.handleDefault
    }, o.a.createElement("div", {
      style: F.leftArrow
    }), o.a.createElement("div", {
      style: F.rightArrow
    })), o.a.createElement("div", {
      style: F.line
    })), d && o.a.createElement("div", {
      style: F.leftLabelContainer
    }, o.a.createElement("div", {
      style: F.leftLabel
    }, d)), h && o.a.createElement("div", {
      style: F.rightLabelContainer
    }, o.a.createElement("div", {
      style: F.rightLabel
    }, h))));
  };

  s.defaultProps = {
    aspectRatio: "taller",
    handle: null,
    handleSize: 40,
    hover: !1,
    leftImageAlt: "",
    leftImageCss: {},
    leftImageLabel: null,
    onSliderPositionChange: function onSliderPositionChange() {},
    rightImageAlt: "",
    rightImageCss: {},
    rightImageLabel: null,
    skeleton: null,
    sliderLineColor: "#ffffff",
    sliderLineWidth: 2,
    sliderPositionPercentage: .5,
    vertical: !1
  }, t.default = s;
}]);